@import '../../constants/spacing.module.less';

.banner {
  border-radius: 0;

  &.round {
    border-radius: @space-4;
  }

  > * {
    padding: @space-8;
    justify-content: center;
  }
}
